"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const AccordionList = (props) => {
    var _a;
    const [accordions, setAccordions] = (0, react_1.useState)((_a = props === null || props === void 0 ? void 0 : props.accordionList) !== null && _a !== void 0 ? _a : []);
    const [isOpen, setIsOpen] = (0, react_1.useState)([]);
    const accordionRefs = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        if (props.accordionList)
            setAccordions(props.accordionList);
    }, [props.accordionList]);
    (0, react_1.useEffect)(() => {
        if ((accordions === null || accordions === void 0 ? void 0 : accordions.length) > 0)
            setIsOpen(new Array(accordions.length).fill(false));
    }, [accordions]);
    (0, react_1.useEffect)(() => {
        const handleToggle = (index) => {
            setIsOpen((prev) => {
                var _a, _b;
                const state = [...prev];
                state[index] = (_b = (_a = accordionRefs.current[index]) === null || _a === void 0 ? void 0 : _a.open) !== null && _b !== void 0 ? _b : false;
                return state;
            });
        };
        accordionRefs.current.forEach((el, i) => {
            if (el) {
                const toggleHandler = () => handleToggle(i);
                el.addEventListener("toggle", toggleHandler);
                return () => el.removeEventListener("toggle", toggleHandler);
            }
        });
    }, [accordions]);
    const onCloseAll = () => {
        setIsOpen(Array(accordions.length).fill(false));
        accordionRefs.current.forEach((el) => {
            if (el)
                el.open = false;
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "accordion-list", children: [(0, jsx_runtime_1.jsx)("button", { className: "accordion-list__button", onClick: () => onCloseAll(), "aria-label": "Lukk alle", children: "Lukk alle" }), accordions.map((a, i) => ((0, jsx_runtime_1.jsx)(AccordionBlock, { Heading: a.Heading, Content: a.Content, Url: a.Url, ShowReadMoreLink: a.ShowReadMoreLink, isOpen: isOpen[i], ref: (el) => {
                    accordionRefs.current[i] = el;
                } }, `accordion-${i}`)))] }));
};
exports.AccordionList = AccordionList;
const AccordionBlock = react_1.default.forwardRef(({ Heading, Content, isOpen = false, Url, ShowReadMoreLink }, ref) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("details", { className: "accordion-item", ref: ref, children: [(0, jsx_runtime_1.jsxs)("summary", { className: "accordion-item__trigger", "aria-expanded": isOpen, children: [(0, jsx_runtime_1.jsx)("span", { className: "accordion-item__title", dangerouslySetInnerHTML: {
                                    __html: (Heading !== null && Heading !== void 0 ? Heading : "").replace(/<h2>/g, "<h3>").replace(/<\/h2>/g, "</h3>"),
                                } }), (0, jsx_runtime_1.jsx)("span", { className: `accordion-item__icon accordion-item__icon${isOpen ? "--active" : "--inactive"}`, "aria-hidden": true })] }), (0, jsx_runtime_1.jsx)("div", { className: `accordion-item__panel ${ShowReadMoreLink ? "accordion-item__panel--truncate" : ""}`, dangerouslySetInnerHTML: { __html: Content !== null && Content !== void 0 ? Content : "" }, "aria-hidden": !isOpen }), ShowReadMoreLink && (0, jsx_runtime_1.jsx)("a", { href: Url !== null && Url !== void 0 ? Url : "#", children: "Les mer" })] }), (0, jsx_runtime_1.jsx)("hr", { className: "accordion-item__divider" })] }));
});
const renderApp = () => {
    var _a;
    const nodeId = "index-accordion-list-root";
    const appRootNode = document.getElementById(nodeId);
    const props = {};
    if (!appRootNode) {
        console.warn(`Cannot find node with ID '${nodeId}'. The React app cannot be rendered.`);
        return;
    }
    try {
        const accordionListString = (_a = appRootNode.getAttribute("data-list")) !== null && _a !== void 0 ? _a : "{}";
        props.accordionList = JSON.parse(accordionListString);
    }
    catch (e) {
        console.error("Failed to parse props data", e);
    }
    (0, client_1.createRoot)(appRootNode).render(react_1.default.createElement(exports.AccordionList, props));
};
renderApp();
